module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/gold-buyin-button.3f254a94.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/gold-buyin-button.png
// module id = 2991
// module chunks = 11